module.exports = __webpack_public_path__ + "img/pay_cropay.459d1b6c.png";